import { render } from "./CashflowsReinsurance.vue?vue&type=template&id=386ef06e&scoped=true"
import script from "./CashflowsReinsurance.vue?vue&type=script&lang=js"
export * from "./CashflowsReinsurance.vue?vue&type=script&lang=js"

import "./CashflowsReinsurance.vue?vue&type=style&index=0&id=386ef06e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-386ef06e"]])

export default __exports__